import React, { useEffect } from 'react';

import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';
import useNavigation from '@/hooks/useNavigation';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import { onBoardCompleted } from '@/modules/onboarding/helper';
import { UserStatusEnum } from '@/types/schema';

import { useAppConfig } from '../../hooks/useAppConfig';
import authRoutes from '../../pages/auth/routes';
import routes from '../../pages/corporate/routes';

const OnBoardingFlow: React.FC<React.PropsWithChildren> = ({ children }) => {
  const navigation = useNavigation();
  const user = useUserContext();
  const { [FeatureFlags.EnableOnboarding]: showOnBoarding } = useFeatureFlags();
  const { site } = useAppConfig();

  //searchParam return string or null
  const shouldBoarding = showOnBoarding !== false;
  const emailNotVerified = user?.status === UserStatusEnum.EmailNotVerified;
  const currentPath =
    typeof window !== 'undefined' ? window.location.pathname : navigation.asPath.split('?')[0];
  const isSignupV2OnboardingRoute =
    currentPath === authRoutes.SignupV2() ||
    currentPath === authRoutes.VerifyEmail() ||
    currentPath === authRoutes.VerifyEmailV2() ||
    currentPath === authRoutes.VerifyYourself();
  const onboardingRoute = site.isUserOnboardingAiEnabled
    ? authRoutes.VerifyYourself()
    : '/about-yourself';

  useEffect(() => {
    if (site.academySetupCompleted === false && navigation.pathname !== routes.AcademySetup()) {
      // setting onboarding info is async process and after onboarding , redireciton causing infininte redirection , hence loading full page
      window.location.replace(`${window.location.origin}${routes.AcademySetup()}`);
      // navigation.replace(routes.AcademySetup());
    }

    if (
      emailNotVerified &&
      user.id &&
      navigation.pathname !== '/verify-email' &&
      navigation.pathname !== '/verify-email-v2'
    ) {
      const verifyEmailRoute = site.isUserOnboardingAiEnabled
        ? authRoutes.VerifyEmailV2()
        : authRoutes.VerifyEmail();
      navigation.push(verifyEmailRoute, { setFrom: true, appendQuery: false });
    }

    if (
      shouldBoarding &&
      !emailNotVerified &&
      user.id &&
      !onBoardCompleted(user) &&
      !isSignupV2OnboardingRoute &&
      currentPath !== onboardingRoute
    ) {
      navigation.push(onboardingRoute, { setFrom: true, appendQuery: false });
    }
  }, [
    emailNotVerified,
    isSignupV2OnboardingRoute,
    navigation,
    currentPath,
    onboardingRoute,
    shouldBoarding,
    site.academySetupCompleted,
    user,
    site.isUserOnboardingAiEnabled,
  ]);

  return <>{children}</>;
};

export default OnBoardingFlow;
